import React, { useState } from 'react';
import Project from './Project';
import data from './../data/projectsData.js';

function Projects() {
  const [showAll, setShowAll] = useState(false);
  const initialDisplayCount = 6;
  
  const displayedProjects = showAll 
    ? data.ProjectsData 
    : data.ProjectsData.slice(0, initialDisplayCount);
  
  return (
    <div id='projects' className='px-4 sm:px-6 md:px-8 lg:px-16 py-8 sm:py-12 md:py-16 mt-4 sm:mt-0'>
        <div className='mb-8 sm:mb-12'>
            <h1 className='mb-2 tracking-wider font-semibold text-xl sm:text-2xl md:text-3xl lg:text-3xl'>Projects</h1>
            <p className='text-sm sm:text-base text-gray-600 dark:text-gray-400'>Showcasing {data.ProjectsData.length} projects I've built</p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10'>
          {displayedProjects.map((project) => {
              return(<Project key={project.id}
                  image={project.img}
                  name={project.name}
                  live={project.live}
                  source={project.source}
                  desc={project.description}/>)
          })}
        </div>
        
        {data.ProjectsData.length > initialDisplayCount && (
          <div className='flex justify-center mt-10 sm:mt-12'>
            <button 
              onClick={() => setShowAll(!showAll)}
              className='px-6 sm:px-8 py-3 bg-[#ec6e59] hover:bg-[#d95d4a] text-white font-medium rounded-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl text-sm sm:text-base'
            >
              {showAll ? 'Show Less' : `View All ${data.ProjectsData.length} Projects`}
            </button>
          </div>
        )}
    </div>
  );
}

export default Projects;
